<template>
  <a-modal v-bind="$attrs" v-on="$listeners">
    <template v-if="billType !== '5'">
      <template slot="title">
        <template v-if="!isLoading">
          <template v-if="which_bill_temp(1)">
            <h1 class="title-temp-1 font-semibold title-invoice">
              <template v-if="invoice_html && invoice_html.data">
                {{ (invoice_html.record.type === 1 ? 'Invoice ' : 'Trust Fund Request ') + invoice_html.record.factor_no }}
              </template>
            </h1>
          </template>
          <template v-if="which_bill_temp(2)">
            <div class="flex header-modal-bill">
              <div v-if="invoice_html && invoice_html.record && invoice_html.record.to_contact" class="flex flex-col justify-center pl-8 color-amount-due space-y-4 w-2/3" style="background: #41438d">
                <div class="text-3xl">{{ (invoice_html.record.type === 1 ? 'Invoice ' : 'Trust Fund Request ') + invoice_html.record.factor_no }}</div>
                <small>
                  {{ invoice_html.record.to_contact.person ? `${invoice_html.record.to_contact.person.first_name} ${invoice_html.record.to_contact.person.last_name}` : invoice_html.record.to_contact.company.name }}
                </small>
              </div>
              <div class="flex flex-col justify-center items-center w-1/3 color-amount-due" style="background: #393a87 ">
                <small>Amount Due</small>
                <div class="text-3xl" v-if="invoice_html && invoice_html.record">
                  <!-- {{ currencySymbol + (invoice_html.record.total_amount - invoice_html.record.payed_amount).toFixed(2) || '__' }} -->
                  {{ currencySymbol + amountDue }}
                </div>
              </div>
            </div>
          </template>
          <template v-if="which_bill_temp(3)">
            <!--            temp-header-3-->
            <div class="temp-header-3 title-invoice">
              <template v-if="invoice_html && invoice_html.data">
                {{ (invoice_html.record.type === 1 ? 'Invoice ' : 'Trust Fund Request ') + invoice_html.record.factor_no }}
              </template>
            </div>
          </template>
        </template>
      </template>
      <template v-if="isLoading">
        <ASkeleton v-for="n in 8" active avatar />
      </template>
      <div v-else>
        <template v-if="invoice_html && template_data">
          <template v-if="template_data.templates">
            <!--            <a-button type="primary" @click="ExpertPdf">Pdf</a-button>-->
            <a-button
              v-if="approveNotDueDateCallback(invoice_html.record)"
              type="primary"
              @click="goToRecordPaymentOrSendFund(invoice_html.record)"
              class="bnt-payment-bill mb-2"
            >
              Record Payment
            </a-button>
            <template v-if="template_data.templates.template === 1">
              <TemplateOne 
                :items="invoice_html"
                :setting="template_data"
                @finalClose="finalClose"
                @amountDueChanged="handleAmountDueChanged"
              />
            </template>
            <template v-if="template_data.templates.template === 2">
              <TemplateTwo 
                :items="invoice_html"
                :setting="template_data"
                @amountDueChanged="handleAmountDueChanged"
              />
            </template>
            <template v-if="template_data.templates.template === 3">
              <TemplateThree 
                :items="invoice_html"
                :setting="template_data"
                @amountDueChanged="handleAmountDueChanged"
              />
            </template>
          </template>
        </template>
      </div>
    </template>
    <template v-else>
      <template v-if="isLoading">
        <ASkeleton v-for="n in 5" active avatar/>
      </template>
      <template v-else>
        <template v-if="invoice_html">
          <div class="flex flex-col items-center gap-y-4">
            <img :src="invoice_html.avatar" alt="avatar" width="150" class="m-auto"/>
            <div class="font-bold">{{ invoice_html.company_name }}</div>
            <div>{{ invoice_html.company_address }}</div>
          </div>
          <a-descriptions :column="2" class="m-auto block text-center">
            <a-descriptions-item v-if="invoice_html.company_mail" label="Email">{{ invoice_html.company_mail }}</a-descriptions-item>
            <a-descriptions-item v-if="invoice_html.company_tel" label="Tel">{{ invoice_html.company_tel }}</a-descriptions-item>
          </a-descriptions>
          <h3 class="font-bold mt-10 block text-center">OFFICIAL RECEIPT</h3>
          <div class="grid grid-cols-2 md:grid-cols-3 gap-4">
            <a-descriptions class="description-receipt col-span-2" :column="1">
              <a-descriptions-item label="Received From">
                  {{ invoice_html.receive_from }}
              </a-descriptions-item>
              <div v-if="invoice_html.client_address1" class="ml-10">{{ invoice_html.client_address1 }} {{ invoice_html.post_code || '' }} {{ invoice_html.city }}, {{ invoice_html.state }}</div>
              <a-descriptions-item label="Payment For">{{ invoice_html.invoice_no }} - {{ invoice_html.payment_for }}</a-descriptions-item>
              <a-descriptions-item label="Remark">{{ invoice_html.remark || '-' }}</a-descriptions-item>
            </a-descriptions>
            <a-descriptions :column="1">
              <a-descriptions-item label="Receipt No">{{ 'OR00' + invoice_html.receipt_no }}</a-descriptions-item>
              <a-descriptions-item label="Date">{{ invoice_html.receipt_date }}</a-descriptions-item>
              <a-descriptions-item label="Payment Type">{{ invoice_html.payment_type }}</a-descriptions-item>
              <a-descriptions-item label="Bank in Date">{{ invoice_html.receipt_bank_date }}</a-descriptions-item>
            </a-descriptions>
          </div>
          <a-divider/>
          <div v-if="invoice_html.amount" class="flex justify-between items-center gap-2">
            <div class="self-start">{{ invoice_html.char_amount }}</div>
            <div class="flex items-center gap-2">
              <p class="font-bold">Amount:</p>
              <p>{{ currencySymbol + invoice_html.amount }}</p>
            </div>
          </div>
        </template>
      </template>
    </template>
  </a-modal>
</template>

<script>
import Mixin from '../../mixin/mixin'
import Template from '../../template/Template'
import Template2 from '../../template/Template2'
import Template3 from '../../template/Template3'

export default {
  name: 'BillingViewModal',

  inheritAttrs: false,

  mixins: [Mixin],

  components: {
    TemplateOne  :Template,
    TemplateTwo  :Template2,
    TemplateThree:Template3,
  },

  props: {
    // 1 == All Invoices
    // 2 == Draft
    // 3 == Unpaid
    // 4 == Overdue
    // 5 == Receipt
    billType: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    invoice_html: {
      type: Object,
    },
    template_data: {
      type: Object,
    },
    approveNotDueDateCallback: {
      type: Function,
    },
  },

  data() {
    return {
      amountDue: '0.00',
    }
  },

  computed: {
    currencySymbol() {
      return localStorage.getItem('currency_symbol')
    },
  },

  methods: {
    handleAmountDueChanged(amount) {
      this.amountDue = amount
    },
  },
}
</script>

<style>
</style>
